import { Award } from "lucide-react";
import Modal from "../Modal";

export default function TransactionConfirmModal({
  open,
  onOpenChange,
  customer,
  formData,
  onConfirm,
  loading = false
}) {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm({
        customer_name: customer?.name || "Guest Customer",
        mobile: formData.mobile,
        billable_amount: parseFloat(formData.billableAmount)
      });
    }
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange} title="">
      <div className="text-center">
        {/* Success Icon */}
        <div className="mx-auto mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-green-400 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <Award className="h-10 w-10 text-white" />
          </div>
        </div>

        {/* Transaction Details Preview */}
        <div className="space-y-4 mb-6">
          <div className="flex justify-between items-center py-2">
            <span className="text-gray-700 font-medium">Bill Amount:</span>
            <span className="text-lg font-bold">
              {formData.billableAmount ? `₹${parseFloat(formData.billableAmount).toLocaleString('en-IN')}` : '₹0'}
            </span>
          </div>

          <div className="flex justify-between items-center py-2">
            <span className="text-gray-700 font-medium">Customer Name:</span>
            <span className="text-gray-900 font-medium">
              {customer?.name || "Guest Customer"}
            </span>
          </div>

          <div className="flex justify-between items-center py-2">
            <span className="text-gray-700 font-medium">Mobile Number:</span>
            <span className="text-gray-900 font-medium">
              {formData.mobile || 'N/A'}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleConfirm}
            disabled={loading}
            className="w-full bg-green-500 hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-medium py-3 px-6 rounded-lg transition-colors"
          >
            {loading ? "Processing..." : "Deal Now"}
          </button>
          
          <button
            onClick={handleCancel}
            disabled={loading}
            className="w-full text-gray-500 hover:text-gray-700 disabled:text-gray-300 font-medium py-2 transition-colors"
          >
            No, thanks
          </button>
        </div>
      </div>
    </Modal>
  );
}